import { render } from "./entry-stacked.vue?vue&type=template&id=038e3929&scoped=true"
import script from "./entry-stacked.vue?vue&type=script&lang=js"
export * from "./entry-stacked.vue?vue&type=script&lang=js"

import "./entry-stacked.vue?vue&type=style&index=0&id=038e3929&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038e3929"]])

export default __exports__